import { useMutation } from '@tanstack/react-query'
import { FileService } from '../services/FileService'

interface GetShopItemImageUploadUrlParams {
	fileExtension?: string
}

export default function useMutationGetShopItemImageUploadUrl() {
	return useMutation({
		mutationFn: ({ fileExtension = 'webp' }: GetShopItemImageUploadUrlParams) =>
			FileService.getShopItemImageUploadUrl(fileExtension),
	})
}
